import { createAsyncThunk } from '@reduxjs/toolkit';
import { HTTP_GENERIC_STATUS } from 'constants/defaults';
import requestManager from './requestManager';

const handleReject = (rejectWithValue, error) => {
  if (error.response?.headers?.['x-powered-by'] === 'msw')
    return rejectWithValue({ status: error.response.status, errors: { ...error.response.data } });
  if (error.status / 100 === HTTP_GENERIC_STATUS.clientError || error.status / 100 === HTTP_GENERIC_STATUS.serverError)
    return rejectWithValue({ status: error.status, errors: { ...error.data[0] } });

  return rejectWithValue(error);
};

export const searchPersonByDocument = createAsyncThunk(
  'requestOperations/GET_PERSON_BY_DOCUMENT',
  async (documentNumber, { rejectWithValue }) => {
    try {
      const payload = { documentNumber };
      return await requestManager.searchPersonByDocumentNumber(payload);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const getAllCoverages = createAsyncThunk(
  'requestOperations/GET_ALL_COVERAGES',
  async (_, { rejectWithValue }) => {
    try {
      const basicCoverageTask = requestManager.getBasicCoverage();
      const additionalCoverageTask = requestManager.getAdditionalCoverages();
      return (await Promise.all([basicCoverageTask, additionalCoverageTask])).flat();
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const createQuote = createAsyncThunk('requestOperations/CREATE_QUOTE', async (quote, { rejectWithValue }) => {
  try {
    return await requestManager.createQuote(quote);
  } catch (error) {
    return handleReject(rejectWithValue, error);
  }
});

export const updateQuote = createAsyncThunk(
  'requestOperations/UPDATE_QUOTE',
  async (quotePayload, { rejectWithValue }) => {
    try {
      const { id, quote } = quotePayload;
      return await requestManager.updateQuote(id, quote);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const createPerson = createAsyncThunk('requestOperations/CREATE_PERSON', async (person, { rejectWithValue }) => {
  try {
    return await requestManager.createPerson(person);
  } catch (error) {
    return handleReject(rejectWithValue, error);
  }
});

export const createPersonHefesto = createAsyncThunk(
  'requestOperations/CREATE_PERSON_HEFESTO',
  async (person, { rejectWithValue }) => {
    try {
      return await requestManager.createHefesto(person);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const createProposal = createAsyncThunk(
  'requestOperations/CREATE_PROPOSAL',
  async (proposal, { rejectWithValue }) => {
    try {
      return await requestManager.createProposal(proposal);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const acceptTerms = createAsyncThunk(
  'requestOperations/ACCEPT_TERMS',
  async (termAccept, { rejectWithValue }) => {
    try {
      return await requestManager.acceptTerms(termAccept);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const getQuotePDF = createAsyncThunk('requestOperations/DOWNLOAD_QUOTE', async (id, { rejectWithValue }) => {
  try {
    return await requestManager.getQuotePDF(id);
  } catch (error) {
    return handleReject(rejectWithValue, error);
  }
});

export const getPaymentsUrl = createAsyncThunk(
  'requestOperations/GET_PAYMENTS_URL',
  async (sequencial, { rejectWithValue }) => {
    try {
      return await requestManager.getPaymentsUrl(sequencial);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const getProposalDocument = createAsyncThunk(
  'requestOperations/GET_PROPOSAL_DOCUMENT_BY_ORDER_ID',
  async (id, { rejectWithValue }) => {
    try {
      return await requestManager.getProposalDocumentByOrderId(id);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const getAddressByZipCode = createAsyncThunk(
  'requestOperations/GET_ADDRESS_BY_ZIP_CODE',
  async (zipCode, { rejectWithValue }) => {
    try {
      return await requestManager.getAddressByZipCode(zipCode);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);

export const getPersonById = createAsyncThunk(
  'requestOperations/GET_PERSON_BY_ID',
  async (personId, { rejectWithValue }) => {
    try {
      return await requestManager.getPersonById(personId);
    } catch (error) {
      return handleReject(rejectWithValue, error);
    }
  }
);
